import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import {
  addCategory,
  getCategoriesError,
  getCategoriesStatus,
  getCategoriesLoading,
  getCategoriesSuccess,
} from "../../../features/categorySlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import CategoryForm from "./categoryForm";
import { getImageFormFields } from "../../../global/functions/imageHelper";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const AddCategory = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { restaurantId } = useRestaurant();
  const [previewImage, setPreviewImage] = useState(null);
  const status = useSelector(getCategoriesStatus);
  const error = useSelector(getCategoriesError);
  const success = useSelector(getCategoriesSuccess);
  const loading = useSelector(getCategoriesLoading);

  const initialValues = {
    name: "",
  };
  
  const handleFormSubmit = (values) => {
    const imageFields = getImageFormFields(previewImage);
    if (!imageFields.image && !imageFields.mediaId) {
      toast.error("Veuillez sélectionner ou télécharger une image");
      return;
    }
    dispatch(
      addCategory({
        body: {
          name: values.name,
          ...imageFields,
        },
        restaurantId,
      })
    );
  };

  useEffect(() => {
    if (status === "addSuccess") {
      toast.success(success);
      navigate("/category");
    } else if (status === "addError") {
      toast.error(error);
    }
  }, [status, error, success, dispatch, navigate]);

  return (
    <Box m="20px" className="main-application">
      <BackButton/>
      <Header title={t("headers.addCategory")} subtitle={t("headers.addCategorySub")} />
      <CategoryForm
        buttonText={t("common.submit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
        loading={loading}
      />
    </Box>
  );
};

export default AddCategory;
